import { createContext } from 'react';

import { SignUpState } from '../../interfaces/signUp.interface';

export const SignUpStateContext = createContext<SignUpState>({} as SignUpState);
SignUpStateContext.displayName = 'SignUpStateContext';
